'use strict';

angular.module('licensure.services')
    .factory('Notes', ['$http', '$q', function ($http, $q) {
        return {
            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Notes/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (note, value) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/Notes/';
                if (!isUndefined(note.id)) {
                    method = 'PUT'
                    url += note.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        note: note,
                        value: value
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/Notes/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;